import { useEffect, useState } from "react";

export type SortDir = 'asc' | 'desc' | null | undefined;

export interface Sort {
    field: string;
    dir: SortDir;
}

export interface SortParam {
    values: Sort[];
};

const sortsEqual = (left: Sort[], right: Sort[]) => {
    if (left.length !== right.length) return false;

    for (let i = 0; i < left.length; i++) {
        const leftValue = left[i];
        const rightValue = right[i];

        if (leftValue.field !== rightValue.field) return false;
        if (leftValue.dir !== rightValue.dir) return false;
    }

    return true;
}

const serializeSortParam = (param?: SortParam | null) => {
    if (param === undefined || param === null) {
        return null;
    }

    let result: string[] = [];
    for (var sort of param.values) {
        result.push(`${sort.field}!${sort.dir?.replace('e', '')}`);
    }

    return result.join(';');
}

type UseSortParamResult = [
    string | null
];

const useSortParamString: (param?: SortParam | null) => UseSortParamResult = (param?: SortParam | null) => {
    const [ result, setResult ] = useState<string | null>(null);

    useEffect(() => {
        setResult(serializeSortParam(param));
    }, [param]);

    return [
        result
    ]
};

export { sortsEqual, serializeSortParam, useSortParamString };